import React from 'react';

import { useThemeMode } from 'contexts/ThemeContext';
import { ThemeMode } from 'types/enums';
import { CATEGORY_NAMES, METRIC_EVENT_NAMES } from 'metrics/constants';
import { useMatomo } from 'contexts/MatomoContext';

import { Container, Handle, Label, Switch, ToggleSwitchContainer, ToggleSwitchInput } from './style';

function ModeToggle() {
  const { themeMode, toggleTheme } = useThemeMode();
  const { trackEvent } = useMatomo();

  const checked = themeMode === ThemeMode.DARK;

  return (
    <Container>
      <Label>Light</Label>
      <ToggleSwitchContainer>
        <ToggleSwitchInput
          type="checkbox"
          checked={checked}
          onChange={() => {
            const mode = checked ? ThemeMode.LIGHT : ThemeMode.DARK;

            trackEvent({ category: CATEGORY_NAMES.PUBTOOL_EVENTS, action: 'click', name: METRIC_EVENT_NAMES.THEME_MODE(mode) });
            toggleTheme();
          }}
        />
        <Switch>
          <Handle checked={checked} />
        </Switch>
      </ToggleSwitchContainer>
      <Label>Dark</Label>
    </Container>
  );
}

export default ModeToggle;
